module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark d-print-none"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("joshefin.xyz")]), _vm._v(" "), (_vm.currentUser.email) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "main-navbar"
    }
  }, [_c('div', {
    staticClass: "navbar-nav"
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/invoices",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Fakture")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/clients",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Klijenti")]), _vm._v(" "), _c('div', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("KPO")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year,
      staticClass: "dropdown-item",
      attrs: {
        "to": {
          path: '/sales/' + year
        },
        "exact": ""
      }
    }, [_vm._v(_vm._s(year))])
  }), 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/settings",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Podešavanja")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-nav ml-auto"
  }, [(_vm.currentUser.email) ? _c('div', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18 align-middle"
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.currentUser.email) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.signout
    }
  }, [_vm._v("Odjava")])])]) : _vm._e()])])] : _vm._e()], 2), _vm._v(" "), _c('main', [_c('keep-alive', [(_vm.initialized) ? _c('router-view') : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#main-navbar",
      "aria-controls": "main-navbar",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bb2238a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 296
// module chunks = 1